
































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import TransferToSponsorTrigger from './TransferToSponsorTrigger.coffee'

settings =
  name: 'TransferToSponsorTriggerModal'

  resources:
    sponsors:
      resourceName: 'sponsor'
      slug: 'sponsors'
      fetch: false

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, LoadingIndicator }
    mixins: [TransferToSponsorTrigger.trigger()]

    computed:
      modalConfig: -> @modal.config || {}
      avaliableSponsors: ->
        return [] unless @modalConfig.currentSponsor
        (@sponsors || []).filter((sponsor) =>
          sponsor.id isnt @modalConfig.currentSponsor.id
        )

export default VueOptions.vue settings
